"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var engine_1 = require("./engine");
var models_1 = require("./models");
exports.customDateWindow = function (range) {
    return function (table) { return exports.applyDateRangeWindow(table, range); };
};
exports.lastNDateWindow = function (numberOfPoints) {
    return function (table) { return trimMetricTable(table, numberOfPoints); };
};
exports.latestDataDateWindow = function (duration) {
    return function (table) {
        var dateRange = exports.relativeToDateRangeWindow(table, duration);
        return exports.applyDateRangeWindow(table, dateRange);
    };
};
exports.allTimeDateWindow = function () {
    return function (table) { return table; };
};
exports.createRelativeWindow = function (duration) {
    return {
        type: models_1.DateWindowTypes.LATEST_DATA,
        duration: duration,
    };
};
exports.createCustomWindow = function (range) {
    return {
        type: models_1.DateWindowTypes.CUSTOM,
        range: range,
    };
};
exports.createLastNWindow = function (n) {
    return {
        type: models_1.DateWindowTypes.LAST_N,
        n: n,
    };
};
exports.createSpecialWindow = function (specialType) {
    return {
        type: models_1.DateWindowTypes.SPECIAL,
        specialType: specialType,
    };
};
exports.applyMaxWindow = function (table) {
    return trimMetricTable(table, 1000);
};
exports.applyWindowFunction = function (table, func) {
    return exports.applyMaxWindow(func(table));
};
exports.windowFuncFromWindow = function (dateWindow) {
    switch (dateWindow.type) {
        case models_1.DateWindowTypes.CUSTOM:
            var customWindow = dateWindow;
            return exports.customDateWindow(customWindow.range);
        case models_1.DateWindowTypes.LAST_N:
            var lastNWindow = dateWindow;
            return exports.lastNDateWindow(lastNWindow.n);
        case models_1.DateWindowTypes.LATEST_DATA:
            var latestWindow = dateWindow;
            return exports.latestDataDateWindow(latestWindow.duration);
        case models_1.DateWindowTypes.SPECIAL:
        default:
            return exports.allTimeDateWindow();
    }
};
exports.applyWindow = function (metricTable, dateWindow) {
    return exports.applyWindowFunction(metricTable, exports.windowFuncFromWindow(dateWindow));
};
var trimMetricTable = function (metricTable, numberOfPoints) {
    return metricTable.slice(-numberOfPoints);
};
// apply a fully inclusive date range window to the provided metricTable
exports.applyDateRangeWindow = function (metricTable, dateRange) {
    if (!dateRange) {
        return metricTable;
    }
    var windowedMetric = [];
    metricTable.forEach(function (point) {
        if (engine_1.withinRange(dateRange, point.timestamp)) {
            windowedMetric.push(point);
        }
    });
    return windowedMetric;
};
exports.dateWindowOptions = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.MINUTE, numberOfUnits: 1 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.MINUTE, numberOfUnits: 3 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.MINUTE, numberOfUnits: 15 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.MINUTE: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.HOUR, numberOfUnits: 1 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.HOUR, numberOfUnits: 3 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.HOUR, numberOfUnits: 12 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.HOUR: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 1 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 3 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 7 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 30 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.DAY: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 7 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 30 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 90 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.DAY, numberOfUnits: 365 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.WEEK: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.WEEK, numberOfUnits: 4 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.WEEK, numberOfUnits: 12 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.WEEK, numberOfUnits: 52 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.MONTH: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.MONTH, numberOfUnits: 12 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.MONTH, numberOfUnits: 60 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return [
                exports.createRelativeWindow({ unit: models_1.DateTrunc.QUARTER, numberOfUnits: 4 }),
                exports.createRelativeWindow({ unit: models_1.DateTrunc.QUARTER, numberOfUnits: 8 }),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.UNKNOWN: {
            return [
                exports.createLastNWindow(30),
                exports.createLastNWindow(100),
                exports.createLastNWindow(300),
                models_1.ALL_TIME_DATE_WINDOW,
            ];
        }
        default: {
            return [exports.defaultDateWindow(dateTrunc), exports.defaultDateWindow(models_1.DateTrunc.NONE)];
        }
    }
};
exports.defaultDateWindow = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.MINUTE,
                numberOfUnits: 3,
            });
        }
        case models_1.DateTrunc.MINUTE: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.HOUR,
                numberOfUnits: 3,
            });
        }
        case models_1.DateTrunc.HOUR: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 7,
            });
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 90,
            });
        }
        case models_1.DateTrunc.MONTH: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.MONTH,
                numberOfUnits: 12,
            });
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.WEEK,
                numberOfUnits: 52,
            });
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.QUARTER,
                numberOfUnits: 8,
            });
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return exports.createRelativeWindow({
                unit: models_1.DateTrunc.YEAR,
                numberOfUnits: 5,
            });
        }
        case models_1.DateTrunc.NONE: {
            return models_1.ALL_TIME_DATE_WINDOW;
        }
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return exports.createLastNWindow(100);
        }
    }
};
exports.defaultNumberOfPoints = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND:
        case models_1.DateTrunc.MINUTE: {
            return 180;
        }
        case models_1.DateTrunc.HOUR: {
            return 72;
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 90;
        }
        case models_1.DateTrunc.MONTH:
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 12;
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 4;
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 5;
        }
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return 100;
        }
    }
};
exports.relativeToDateRangeWindow = function (table, relativeWindow) {
    if (relativeWindow.unit === models_1.DateTrunc.NONE || relativeWindow.unit === models_1.DateTrunc.UNKNOWN) {
        return undefined;
    }
    var lastPoint = engine_1.getLatestValue(table);
    if (!lastPoint || !lastPoint.timestamp) {
        return undefined;
    }
    else {
        return rangeRelativeToDate(lastPoint.timestamp, relativeWindow);
    }
};
// DateRange is fully inclusive, but in the case of relativeDateRanges, we want
// to apply an (exclusive, inclusive] range, so we adjust dateRange.first by
// the smallest unit available
var rangeRelativeToDate = function (date, relativeWindow) {
    var unitForMoment = engine_1.momentStringFromDateTrunc(relativeWindow.unit);
    var first = adjustDateForwardByOneMillisecond(engine_1.dateBefore(date, relativeWindow.numberOfUnits, unitForMoment));
    return { first: first, last: date };
};
var adjustDateForwardByOneMillisecond = function (date) { return moment(date).add(1, 'ms').toDate(); };
//# sourceMappingURL=dateWindowEngine.js.map